export const rosterColumnHeader = (label: string) => () => (
  <span className="min-w-0 flex-1 leading-tight wrap-anywhere whitespace-normal">
    {label}
  </span>
);
